import { render, staticRenderFns } from "./workStart4.vue?vue&type=template&id=be42dc5e&scoped=true&"
import script from "./workStart4.vue?vue&type=script&lang=js&"
export * from "./workStart4.vue?vue&type=script&lang=js&"
import style0 from "./workStart4.vue?vue&type=style&index=0&id=be42dc5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be42dc5e",
  null
  
)

export default component.exports